module.exports = __webpack_public_path__ + "static/media/Stop Sign.f53fe12e.png";